import { fromPairs, get } from 'lodash';
import { getExpressionValue } from '../../../schema/expressions/evaluate/getExpressionValue';
import { getMaterializedExpressionReferences } from '../../../schema/expressions/evaluate/getMaterializedExpressionReferences';
import { conditionResultToBoolean } from '../../../schema/widgets/hooks/conditionResultToBoolean';
import { IBooleanCondition } from './IBooleanCondition';
/**
 * Funzione sincrona che risolve una condizione booleana,
 * permette la valutazione di espressioni e riferimenti dentro
 * gli hook.
 */
export function resolveBooleanCondition(inputs: {
  name: string;
  condition: IBooleanCondition | null | undefined;
  formValues: Record<string, any> | null;
}) {
  const { condition, name, formValues } = inputs;

  const expression =
    condition?.type === 'expression' ? condition?.expression : null;

  const { references } = getMaterializedExpressionReferences({
    name,
    expression,
  });

  const variables = fromPairs(
    references.map(r => [r.id, get(formValues, r.absolutePath)]),
  );

  // Recupera il valore dell'espressione
  const expressionValue = getExpressionValue({
    name,
    expression,
    references,
    variables,
  });

  return conditionResultToBoolean(condition, expressionValue);
}
